
import React, { useRef, useState, useEffect } from 'react';

// language
import { injectIntl, IntlShape } from 'react-intl';

// axios
import axios from 'axios';
import { apiClient } from 'api-client';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { setRefresh } from 'redux/actions/pageActions';
import { setOrderForm } from 'redux/actions/ordersActions';

// alerts
import { useSnackbar } from "notistack";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "components/FormField";

// icons
import { orderIcon } from 'assets/icons';

// utils
import { formatDateTime } from 'utils';

// enumns
import { orderEditEnum, orderAwaitingPaymentEnum } from 'common/enums/DevicesStateEnum';

// types
import { OrderData } from 'types/typesRedux';

interface Props {
  intl: IntlShape,
  handleOpenModalFine?: (type: 'fine' | 'order', bool: boolean) => void,
}

function OrderInfo( { intl, handleOpenModalFine } :Props ): JSX.Element {

  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const order = useSelector( (state: OrderData) => state.orderDetail.order )

  const isActiveInput = useRef<HTMLInputElement>(null);

  const [ isNewStatus, setIsNewStatus ] = useState(false);
  const [autocompleteValue, setAutocompleteValue] = useState('');

  // // Handle close order /////////////////////////////
  // const closeOrder = async ( id: number ) => {
  //   const cancelToken = axios.CancelToken.source()

  //   try {
  //     await apiClient.post(`/v1/orders/${id}/close`,{
  //       cancelToken:cancelToken.token
  //     }
  //     ).then( ( response ) => {
  //       if ( response ) {
  //         enqueueSnackbar(`${intl.formatMessage({id:'orderAlert.closeOrder.true'})}`, { variant: 'success' });
  //         dispatch(setRefresh( { refreshOrder: true } ));
  //         dispatch(setOrderForm( { status: '' } ));
  //       }
  //   });
  //   } catch ( err ){
  //     if (axios.isCancel(err)) {
  //       console.log("canceled");
  //     } else {
  //       enqueueSnackbar(`${intl.formatMessage({id:'orderAlert.closeOrder.false'})}`, { variant: 'error' });
  //     }
  //   };

  //   setTimeout(() => {
  //     setAutocompleteValue(null);
  //   }, 100);
    
  //   return () => cancelToken.cancel();
  // }

  // Handle close order /////////////////////////////
  const cancelOrder = async ( id: number ) => {
    const cancelToken = axios.CancelToken.source()

    try {
      await apiClient.post(`/v1/orders/${id}/cancel`,{
        cancelToken:cancelToken.token
        }
      ).then( ( response ) => {
        if ( response ) {
          enqueueSnackbar(`${intl.formatMessage({id:'orderAlert.cancelOrder.true'})}`, { variant: 'success' });
          dispatch(setRefresh( { refreshOrder: true } ));
          dispatch(setOrderForm( { status: '' } ));
        }
    });
    } catch ( err ){
      if (axios.isCancel(err)) {
      } else {
        enqueueSnackbar(`${intl.formatMessage({id:'orderAlert.cancelOrder.false'})}`, { variant: 'error' });
      }
    };
    return () => cancelToken.cancel();
  }

  // set data from inputs to redux
  const handleInputItem = ( e: React.SyntheticEvent<Element, Event>, newValue: string) => {
    let status = newValue;
    dispatch(setOrderForm( {
        status: status,
      }
    ));
    setIsNewStatus(true);
  };  

  // If submit, edit order
  // const handleChangeStatus = async () => {    
  //   if ( orderForm.status === `${intl.formatMessage({id:'order.detail.cancel'})}` ) {
  //     cancelOrder( order.id );
  //   } else if ( orderForm.status === `${intl.formatMessage({id:'order.detail.close'})}` ) {
  //     closeOrder( order.id );
  //   }
  // };

  // useEffect(() => {
  //   if ( isNewStatus ) {
  //     handleChangeStatus();
  //   }
  // }, [ isNewStatus ]);

  const handleColorStatus = () => {
    if ( order.status === intl.formatMessage({id:'order.detail.in_progress'}) ) {
      return '#006FEE';
    } else if ( order.status === intl.formatMessage({id:'order.detail.awaiting_payment'}) ) {
      return '#F5A524';
    } else if ( order.status === intl.formatMessage({id:'order.detail.completed'}) ) {
      return '#309B0A';
    } else {
      return '#DD2626';
    }
  }

  const handleOrdersButton = () => {
    if ( order.status === intl.formatMessage({id:'order.detail.in_progress'}) ) {
      return '#006FEE';
    } else if ( order.status === intl.formatMessage({id:'order.detail.awaiting_payment'}) ) {
      return '#F5A524';
    } else if ( order.status === intl.formatMessage({id:'order.detail.completed'}) ) {
      return '#309B0A';
    } else {
      return '#DD2626';
    }
  }
     
  return (

    <MDBox        
      sx= {{ width: "20rem", display: "flex",
        flexDirection: "column",
        padding: "0.8rem 1.5rem", backgroundColor: "#ffffff",
        borderRadius: "0.75rem",
      }}
    >

      <MDBox
        sx= {{ 
          width: "100%", display: "flex", flexDirection: "column",                
        }}
      >
        <MDBox 
          sx= {{ 
            width: "100%", display: "flex", flexDirection: "row", 
            justifyContent: "flex-start",
          }}
        >
          <MDBox className= "badge"
            sx={{ 
              // backgroundColor: "#17C063",
              p: 1, mt: -4, ml: 0,
              borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
            }}
              display="grid"
              justifyContent="center"
              alignItems="center"
              bgColor="#17C063"
              color="white"
              width="4.5rem"
              height="4.5rem"
              shadow="md"
              borderRadius="lg"
              variant="gradient"  
              fontSize= "2.2rem"        
          >
            {orderIcon}
          </MDBox>

          <MDBox
            sx={{
              display: "flex", flexDirection: "column",
              alignItems: "flex-start", marginLeft: "1rem",
            }}
          >
            <MDTypography
              sx={{
                fontSize: "1.2rem", fontWeight: "700",
              }}
            >
              {intl.formatMessage({id:'order.detail.title'})}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "400",
                color: "#807E7B", marginTop: "-0.1rem",
              }}
            >
              {order.id}
            </MDTypography>
          </MDBox>            
        </MDBox>
      </MDBox>

      <MDBox
        sx={{
          display: 'flex', flexDirection: 'column',
          alignItems: "flex-start",
        }}
      >
        <MDTypography
          sx={{
            fontSize: "0.75rem", fontWeight: "700",
          }}
        >
          {order.fullName}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "0.625rem", fontWeight: "400",
            color: "#807E7B",
          }}
        >
          {order.email}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "0.625rem", fontWeight: "400",
            color: "#807E7B",
          }}
        >
          {order.phone}
        </MDTypography>
      </MDBox>

      <Divider
        orientation="horizontal"
        flexItem
        sx={{ 
          width: '100%', height: '1px', marginTop: "0.3rem", 
          marginBottom: "0rem", background: 'black',
        }}
      />            
                
      <MDBox
        sx={{
          display: "flex", flexDirection: "row",
          justifyContent: "space-between",  marginTop: "0.3rem",
        }}
      >
        <MDTypography 
          sx={{
            fontSize: "0.75rem", fontWeight: "400",
          }}
        >
          {intl.formatMessage({id:'order.detail.status'})}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "0.75rem", fontWeight: "700",
            color: handleColorStatus(),
          }}
        >
          {order.status}
        </MDTypography>
      </MDBox>                       
      <MDBox
        sx={{
          display: "flex", flexDirection: "row",
          justifyContent: "space-between",  marginTop: "0.3rem",
        }}
      >
        <MDTypography 
          sx={{
            fontSize: "0.75rem", fontWeight: "400",
          }}
        >
          {intl.formatMessage({id:'order.detail.payment'})}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "0.75rem", fontWeight: "700",
            color: handleColorStatus(),
          }}
        >
          {order.paymentStatus ?? 'Čaká na cenu'}
        </MDTypography>
      </MDBox>

      <Divider
        orientation="horizontal"
        flexItem
        sx={{ 
          width: '100%', height: '1px', marginTop: "0.3rem", 
          marginBottom: "0rem", background: 'black',
        }}
      />

      <MDBox
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "space-between",
          paddingLeft: "1rem", paddingBottom: "1.1rem",
          paddingTop: "0.3rem",
        }}
      >
        <MDBox
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            // Pseudo-element ::before
            "&::before": {
              content: '""',
              position: "absolute",
              left: "-1rem",
              top: "0.5rem",
              zIndex: 10,
              height: "8px",
              width: "8px",
              borderRadius: "0.75rem",
              backgroundColor: "#309B0A",
            },
            // Pseudo-element ::after
            "&::after": {
              content: '""',
              position: "absolute",
              left: "-12.5px",
              top: "1rem",
              height: "2.2rem",
              transform: "translateX(-50%)",
              border: "1px dashed",
              borderColor: "#787F78",
            },
          }}
        >
          <MDTypography
            sx={{
              fontSize: "0.625rem", fontWeight: "400",
              color: "#807E7B", paddingTop: "0.2rem",
            }}
          >
            {intl.formatMessage({id:'order.detail.startPlace'})}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.75rem", fontWeight: "700",
            }}
          >
            {order.startPlace}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.625rem", fontWeight: "400",
              color: "#807E7B",
            }}
          >
            {order.createdAt}
          </MDTypography>
        </MDBox>

      </MDBox>


      { order.finishPlace && (
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "space-between",
            paddingLeft: "1rem",
          }}
        >
          <MDBox
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              "&::before": {
                content: '""',
                position: "absolute",
                left: "-1rem",
                top: "0.5rem",
                zIndex: 10,
                height: "8px",
                width: "8px",
                borderRadius: "0.75rem",
                backgroundColor: "#F5A524", // rovnaká farba ako vyššie, ak chceš
              },
              "&::after": {
                content: '""',
                position: "absolute",
                left: "-12.5px",
                top: "-18px", // Tailwind after:-top-[18px]
                height: "1.5rem", // h-6 => 24px
                transform: "translateX(-50%)",
                border: "1px dashed",
                borderColor: "#787F78",
              },
            }}
          >
            <MDTypography
              sx={{
                fontSize: "0.625rem", fontWeight: "400",
                color: "#807E7B", paddingTop: "0.2rem",
              }}
            >
              {intl.formatMessage({id:'order.detail.finishPlace'})}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "700",
              }}
            >
              {order.finishPlace}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.625rem", fontWeight: "400",
                color: "#807E7B",
              }}
            >
              {order.completedAt}
            </MDTypography>
          </MDBox>

        </MDBox>
      )} 

      <Divider
        orientation="horizontal"
        flexItem
        sx={{ 
          width: '100%', height: '1px', marginTop: "0.3rem", 
          marginBottom: "0rem", background: 'black',
        }}
      />

      <MDBox
        sx={{
          display: "flex", flexDirection: "row",
          justifyContent: "space-between", alignItems: "center",
          marginTop: "0.3rem", marginBottom: "0.3rem",
        }}
      >
        <MDTypography
          sx={{
            fontSize: "0.75rem", fontWeight: "400",
            paddingTop: "0.1rem",
          }}
        >
          {intl.formatMessage({id:'order.detail.price'})}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "1.2rem", fontWeight: "700",
          }}
        >
          {order.price}&nbsp; {intl.formatMessage({id:'currency'})}
        </MDTypography>
      </MDBox>

      <Divider
        orientation="horizontal"
        flexItem
        sx={{ 
          width: '100%', height: '1px', marginTop: "0rem", 
          marginBottom: "0rem", background: 'black',
        }}
      />

      <MDBox
        sx={{
          display: "flex", flexDirection: "row",
          justifyContent: "space-between", marginTop: "0.7rem",
          marginBottom: "0.5rem"
        }}
      >
        { order.status === intl.formatMessage({ id: 'order.detail.in_progress' })
          ? (
            <MDButton 
              variant="outlined" 
              color="error" 
              onClick={() => cancelOrder( order.id )}
            >
              { intl.formatMessage({ id: 'button.cancelOrder' }) }                  
            </MDButton>
          )
          : order.status === intl.formatMessage({ id: 'order.detail.awaiting_payment' })
            ? (
              <MDButton 
                variant="outlined" 
                color="error" 
                onClick={() => cancelOrder( order.id )}
              >
                { intl.formatMessage({ id: 'button.cancelOrder' }) }                  
              </MDButton>
            )
            : null
        }  

        { order.status === intl.formatMessage({ id: 'order.detail.in_progress' })
          ? (
            <MDButton 
              variant="contained" 
              color="error" 
              onClick={() => handleOpenModalFine( 'order', true )}
            >
              { intl.formatMessage({ id: 'button.closeOrder' }) }                  
            </MDButton>
          )
          : (order.status === intl.formatMessage({ id: 'order.detail.cancelled'}) || order.status === intl.formatMessage({ id: 'order.detail.completed'})  )
            ? (
              <MDBox
                sx={{
                  display: "flex", flexDirection: "row",
                  justifyContent: "flex-end", width: "100%"
                }}
              >
                <MDButton 
                  variant="contained"
                  color="warning" 
                  onClick={() => handleOpenModalFine( 'fine', true )}
                >
                  { intl.formatMessage({ id: 'button.addFines' }) }                  
                </MDButton>
              </MDBox>
            )
            : null
        }      
      </MDBox>

    </MDBox>
  );
}

export default injectIntl(OrderInfo);
